module.exports = __webpack_public_path__ + "media/images/symbols/bg-logo-e66a659037f821298c1f82ed7df2f035.png";